module.exports = __webpack_public_path__ + "img/pool-view.7bb25acc.jpg";